import axios from "axios";
import config from "../../../../config";
import junctionData from "./json_files/junction.json";
import rcmData from "./json_files/rcm.json";
import newJunction from "./json_files/junstion_old_data.json"

const SYNCHROEU_URL = config.SYNCHROEU_URL;
const API_URL = config.TRAFFIC;

function getAuthHeaders() {
  const token = localStorage.getItem("keycloak-token");
  if (!token) {
    throw new Error("Missing auth token — please login again.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchJunctionList() {
  const res = await axios.get(
    `${SYNCHROEU_URL}/pg_junction_thess/list_junctions`,
    { headers: getAuthHeaders() }
  );
  return res.data;
}

export async function fetchJunctionData() {
  const res = await axios.get(
    `${SYNCHROEU_URL}/pg_junction_thess/intersections_data`,
    { headers: getAuthHeaders() }
  );
  return newJunction;
}

export async function fetchRcmList() {
  const res = await axios.get(`${API_URL}/intersections`, {
    headers: { "Accept-Profile": "detectors" },
  });
  return res.data;
}

export async function fetchRcmData() {
  const res = await axios.get(`${API_URL}/rpc/intersection_rcm`, {
    headers: { "Accept-Profile": "detectors" },
  });
  // return res.data;
  return rcmData;
}


